import { render } from "./Savings_Products.vue?vue&type=template&id=4302183f"
import script from "./Savings_Products.vue?vue&type=script&lang=js"
export * from "./Savings_Products.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__